import {Component, OnInit, Output, EventEmitter, Input, NgZone, TemplateRef} from '@angular/core';
import {HttpClient, HttpParams, HttpHeaders} from '@angular/common/http';
import {IDropdownSettings} from 'ng-multiselect-dropdown';
import * as _ from 'lodash';
import {Router} from '@angular/router';
import {TSFuntionService} from '../../services/ts-funtion.service';
import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';
import {BsModalService, BsModalRef, ModalOptions} from 'ngx-bootstrap/modal';
import {BsDatepickerViewMode} from 'ngx-bootstrap/datepicker/models';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private router: Router,
    private System: TSFuntionService,
    private modalService: BsModalService,
  ) {
  } //
  modalRef: BsModalRef;

  public settings = {};
  minMode: BsDatepickerViewMode = 'year';
  Legend = true;
  IsCompanyFilter = false;
  // Export to excel data
  arrDataExport: any = [];

  //#region GetFilter Data
  _RequestType = [];
  _Status = [];
  _Currency = [];
  _Company = [];
  _Requester = [];
  IsChartOpen = true;
  IsSearchOpen = false;
  //#endregion

  //#region Table
  //#region 1. ตัวแปรในการทำงาน
  // Standard Data Grid
  FilterGrid = {
    sSearch: '',
    nReqType: [],
    nStatusID: [],
    sCompanyCode: [],
    sRequester: [],
    sSearchID: '',
    dDate: [],
  };
  // chart
  FilterChart = {
    // sYear: new Date().getFullYear().toString(),
    // sYear: Date,
    sYear: '',
    sCurrency: '',
  };
  OptionGrid = {
    nCurrentPage: 1,
    maxSize: 7,
    nPageSize: 10,
    nTotalItem: 0,
    ArrPageSize: [
      {sValue: 10},
      {sValue: 20},
      {sValue: 50},
      {sValue: 100}
    ]
  };
  IsHeaderSort = '';
  SortDirection = '';
  SortICO = 'fas fa-sort';
  IcoSort = 'fas fa-sort';
  IcoSortDesc = 'fas fa-sort-down';
  IcoSortAsc = 'fas fa-sort-up';
  sDetailData = '';
  _ArrData = [];
  _ArrDataBind = [];
  _toExport = [];
  //#endregion
  arrGL: any;
  //#region 2. Header Colomn
  Columns = [
    {ColumnName: '', SortField: '', Width: '4%'},
    {ColumnName: '', SortField: '', Width: '3%'},
    {ColumnName: 'Req. No.', SortField: 'sRequestCode', Width: '10%'},
    {ColumnName: 'Type', SortField: 'sReqType', Width: '16%'},
    {ColumnName: 'Vendor / Customer Name', SortField: 'sVendorName', Width: '22%'},
    {ColumnName: '', SortField: '', Width: '3%'}, // eject this columns
    {ColumnName: 'Due Date', SortField: 'dDueDate', Width: '8%'},
    {ColumnName: 'Net Amount', SortField: 'nTotalAmount', Width: '13%'},
    {ColumnName: 'Cur', SortField: 'sCurrency', Width: '5%'},
    {ColumnName: 'Description', SortField: 'sDescription', Width: '12%'},
    {ColumnName: 'Status', SortField: 'sStatusName', Width: '13%'},
    {ColumnName: '', SortField: '', Width: '4%'}
  ];

  IsApprove = false;

  ngOnInit() {
    this.FilterChart.sCurrency = 'THB';
    this.FilterChart.sYear = new Date().getFullYear().toString();
    this.ngAfterViewInit();
    this.ThemesChartView();
    this.SetDataOnPageLoad();
    this.settings = {
      singleSelection: false,
      idField: 'sValue',
      textField: 'sText',
      enableCheckAll: true,
      selectAllText: 'Select All',
      unSelectAllText: 'Unselect All',
      allowSearchFilter: true,
      limitSelection: -1,
      clearSearchFilter: true,
      maxHeight: 197,
      itemsShowLimit: 1,
      searchPlaceholderText: 'Search',
      noDataAvailablePlaceholderText: 'No Data',
      closeDropDownOnSelection: false,
      showSelectedItemsAtTop: false,
      defaultOpen: false
    };
    const ua = this.System.GetUserStorage();
    if (ua) {
      this.IsCompanyFilter = (ua.nRole == 2);
      if (this.IsCompanyFilter) {
        this.FilterGrid.sCompanyCode = [];
        ua.lstCompCode.forEach(f =>
          this.FilterGrid.sCompanyCode.push({sValue: f.sCompCode, sText: f.sCompName})
        );
      }
      this.GetData();
    }

  }

  SetDataOnPageLoad() {
    // RequestType
    this.http.get<any>(this.System.SiteName + 'api/Home/_GetRequestType').subscribe(res => {
      this._RequestType = res;
    });
    // Status
    this.http.get<any>(this.System.SiteName + 'api/Home/_GetStatus').subscribe(res => {
      this._Status = res;
    });
    // Currency
    this.http.get<any>(this.System.SiteName + 'api/Home/_GetCurrency').subscribe(res => {
      this._Currency = res;
    });

    this.http.get<any>(this.System.SiteName + 'api/Home/_Company').subscribe(res => {
      this._Company = res;
    });
    // User Requester
    this.http.get<any>(this.System.SiteName + 'api/Home/_GetRequester').subscribe(res => {
      this._Requester = res;
    });
  }

  //#endregion

  //#region Event
  // Event ตอนกด Click Header
  SortHeaderClick(ColumnName: string, SortField: string) {
    if (ColumnName) {
      if (ColumnName === this.IsHeaderSort) {
        this.SortDirection = this.SortDirection === 'asc' ? 'desc' : 'asc';
        this.SortICO = (this.SortDirection === 'asc') ? this.IcoSortAsc : this.IcoSortDesc;
      } else {
        this.SortICO = this.IcoSortAsc;
        this.SortDirection = 'asc';
      }
      this.IsHeaderSort = ColumnName;
      this._ArrData = _.orderBy(this._ArrData, [SortField], [this.SortDirection]);
      this.BindDataTable();
    }
  }

  PageSizeChange() {
    setTimeout(() => {
      this.OptionGrid.nCurrentPage = 1;
      this.BindDataTable();
    });
  }

  PageChanged(event: any) {
    this.OptionGrid.nCurrentPage = event.page;
    this.BindDataTable();
  }

  //#endregion

  GetData() {
    const _this = this;
    this.OptionGrid.nCurrentPage = 1;
    this.System.BlockUI();
    const _sReqType: string = this.FilterGrid.nReqType.length > 0 ? this.FilterGrid.nReqType.map(e => e.sValue).join(',') : '';
    const _sStatus: string = this.FilterGrid.nStatusID.length > 0 ? this.FilterGrid.nStatusID.map(e => e.sValue).join(',') : '';
    const _sCompanyCode: string = this.FilterGrid.sCompanyCode.length > 0 ? this.FilterGrid.sCompanyCode.map(e => e.sValue).join(',') : '';
    const _sRequester: string = this.FilterGrid.sRequester.length > 0 ? this.FilterGrid.sRequester.map(e => e.sValue).join(',') : '';

    if (this.FilterGrid.dDate == null) {
      this.FilterGrid.dDate = [];
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const data = {
      sSearch: this.FilterGrid.sSearch,
      sReqType: _sReqType,
      sStatus: _sStatus,
      sSearchID: this.FilterGrid.sSearchID,
      dDate: this.FilterGrid.dDate,
      sCompanyCode: _sCompanyCode,
      sRequester: _sRequester,
    };

    const ITEM = JSON.stringify(data);

    this.http.post<any>(this.System.SiteName + 'api/Home/ListData', ITEM, {headers, responseType: 'json'}).subscribe(res => {
      if (res) {
        this._ArrData = res;
      } else {
        this._ArrData = [];
      }
      this.BindDataTable();
    });
  }

  BindDataTable() {
    const user = this.System.GetUserStorage();
    const nRole = user.nRole;
    const status = this.Getstatus(nRole);
    this.OptionGrid.nTotalItem = this._ArrData.length;

    const nPageSize = this.System.ParseIntToZero(this.OptionGrid.nPageSize);
    const nStartIndex_Take = (this.OptionGrid.nCurrentPage - 1) * nPageSize;
    const nEndIndex_Take = nPageSize;
    this._ArrDataBind = [];
    this._ArrData.forEach(val => this._ArrDataBind.push(Object.assign({}, val)));
    this._ArrDataBind = this._ArrDataBind.splice(nStartIndex_Take, nEndIndex_Take);
    const nStartItemPage = nStartIndex_Take + 1;
    const nLastItemPage = nStartIndex_Take + this._ArrDataBind.length;
    this.sDetailData = 'Showing ' + nStartItemPage + ' to ' + nLastItemPage + ' of ' + this._ArrData.length + ' Rows';
    this.System.UnBlockUI();
  }

  async EditData(_Item) {
    const user = this.System.GetUserStorage();
    const nRole = user.nRole;
    const nStatus = _Item.nStatusID;
    const nReqType = _Item.nReqType;
    const IsManual = _Item.IsManual;
    let sUrl = '';
    // 0	Cancel
    // 1	Draft
    // 2	Waiting Approve1
    // 3	Recall
    // 4	Waiting Approve2
    // 5	Reject By Approve1
    // 6	Waiting Receiving Doc
    // 7	Reject By Approve2
    // 8	Waiting Verify
    // 9	Waiting Export to SAP
    // 10	Reject By SSC
    // 11	Waiting Payment
    // 12	Waiting Supporting Document
    // 13	Complete

    switch (nRole) {
      case 1: // Admin
        sUrl = '/approve';
        break;
      case 2: // SSC
        switch (nStatus) {
          case 0:
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
          case 7:
          case 10:
            sUrl = '/approve';
            break;
          case 6: // Wait Doc Receiving
            sUrl = '/admin-receivingdoc';
            break;
          case 8: // Wait Adjust Invoice
            sUrl = '/admin-adjust';
            break;
          case 9: // Wait Export to SAP
          case 15: // Wait Export to SAP
            sUrl = '/exportto-sap';
            if (nReqType === 50 || nReqType === 70 || nReqType === 71 || nReqType === 80 || nReqType === 90 || IsManual) {
              sUrl = '/manual-updatefi'
            }
            break;
          case 11: // Waiting Payment
            sUrl = '/admin-payment';
            break;
          case 12: // Waiting Supporting Document
            sUrl = '/admin-supportdoc';
            break;
          case 13: // Complete
            sUrl = '/approve';
            break;
        }
        break;
      case 3: // Approve1
      case 4: // Approve2
        sUrl = '/approve';
        break;
      case 5: // Request
      case 7: //ROService
        switch (nStatus) {
          case 1:
          case 3:
          case 5:
          case 7:
          case 10:
            sUrl = this.GetpathTReq(_Item.nReqType);
            break;
          case 2:
          case 4:
          case 6:
          case 8:
          case 9:
          case 11:
          case 12:
          case 13:
          case 15:
            sUrl = '/approve';
            break;
        }
        break;
      case 6: // SVM
        sUrl = '/approve';
        break;
    }

    const ID = await this.System.Encrypt(_Item.sRequestID);
    await this.router.navigate([sUrl], {queryParams: {str: ID}});
  }

  //#endregion

  // path at status =1
  GetpathTReq(nReqType: number) {
    let sUrl = '';
    switch (nReqType) {
      case 10:
      case 11:
        sUrl = '/paytovendor';
        break;
      case 12:
        sUrl = '/paytoemp';
        break;
      case 20:
        sUrl = '/advancerequest';
        break;
      case 30:
        sUrl = '/clearadvance';
        break;
      case 40:
        sUrl = '/pettycash';
        break;
      case 50:
        sUrl = '/other';
        break;
      case 60:
      case 61:
        sUrl = '/cntype';
        break;
      case 70:
      case 71:
        sUrl = '/billingtocash';
        break;
      case 80:
        sUrl = '/journalvoucher';
        break;
      case 90:
        sUrl = '/receiptvoucher';
        break;
    }
    return sUrl;
  }

  Getstatus(nRole: number) {
    const status = [];
    switch (nRole) {
      case 1:
        status.push(1, 2, 3);
        break;
      case 2:
        status.push(2);
        break;
    }
    return status;
  }

  GetColorText(_Item: any) {
    let sColor = '';
    switch (_Item.nStatusID) {
      case 13:
        sColor = '_text_green_paster';
        break;
      case 3:
      case 5:
      case 7:
      case 10:
        sColor = '_text_red_paster';
        break;
    }
    return sColor;
  }

  ngAfterViewInit() {
    const chart = am4core.create('PieChart', am4charts.PieChart3D);
    chart.hiddenState.properties.opacity = 0;
    this.http.get<any>(this.System.SiteName + 'api/Home/GetPieChart1').subscribe(res => {
      if (res) {
        chart.data = res;
      }
    });
    chart.innerRadius = am4core.percent(0); // ความกว้างของวงตรงกลาง
    chart.depth = 10; // ความสูงของมิติ
    const series = chart.series.push(new am4charts.PieSeries3D());
    series.dataFields.value = 'litres';
    series.dataFields.depthValue = 'litres'; // ชื่อ เอาออก
    series.dataFields.category = 'country';
    series.slices.template.cornerRadius = 5;
    // series.colors.step = 1; //โทนสีฟ้า 1 / 20
    series.colors.list = [
      am4core.color('#C4B3C3'),
      am4core.color('#FBF1D5'),
      am4core.color('#F7D07A'),
      am4core.color('#FFAE92'),
      am4core.color('#C70039'),
      am4core.color('#47BDD7'),
      am4core.color('#B5E3EA'),
      am4core.color('#48D1CC'),
      am4core.color('#FDB4BF'),
      am4core.color('#D3ECDC'),
      am4core.color('#3A547E'),
      am4core.color('#D0C6DE'),
    ];
    series.labels.template.disabled = false; // เปิดเส้นโยง
    this.Legend = true;
    am4core.addLicense('CH208466903'); // รหัสรายเส้น เพาระว่าซื้อมาแล้วต้องใช้ไม่ให้ขึ้นเส้นโลโก
  }

  LegendData(value) {
    am4core.addLicense('CH208466903'); // รหัสรายเส้น เพาระว่าซื้อมาแล้วต้องใช้ไม่ให้ขึ้นเส้นโลโก
    if (value == 1) {
      const chart = am4core.create('PieChart', am4charts.PieChart3D);
      chart.hiddenState.properties.opacity = 0;
      this.http.get<any>(this.System.SiteName + 'api/Home/GetPieChart').subscribe(res => {
        if (res) {
          chart.data = res;
        }
      });
      chart.innerRadius = am4core.percent(0); // ความกว้างของวงตรงกลาง
      chart.depth = 10; // ความสูงของมิติ
      const series = chart.series.push(new am4charts.PieSeries3D());
      series.dataFields.value = 'litres';
      series.dataFields.depthValue = 'litres'; // ชื่อ เอาออก
      series.dataFields.category = 'country';
      series.slices.template.cornerRadius = 5;
      // series.colors.step = 1; //โทนสีฟ้า 1 / 20
      // series.colors.list = [
      //  am4core.color("#C4B3C3"),
      //  am4core.color("#47BDD7"),
      //  am4core.color("#FBF1D5"),
      //  am4core.color("#B5E3EA"),
      //  am4core.color("#F7D07A"),
      //  am4core.color("#D3ECDC"),
      //  am4core.color("#FFAE92"),
      //  am4core.color("#D0C6DE"),
      //  am4core.color("#48D1CC"),
      //  am4core.color("#C70039"),
      //  am4core.color("#FDB4BF"),
      //  am4core.color("#3A547E"),
      // ];
      series.colors.list = [
        am4core.color('#C4B3C3'),
        am4core.color('#FBF1D5'),
        am4core.color('#F7D07A'),
        am4core.color('#FFAE92'),
        am4core.color('#C70039'),
        am4core.color('#47BDD7'),
        am4core.color('#B5E3EA'),
        am4core.color('#48D1CC'),
        am4core.color('#FDB4BF'),
        am4core.color('#D3ECDC'),
        am4core.color('#3A547E'),
        am4core.color('#D0C6DE'),
      ];

      chart.legend = new am4charts.Legend(); // ตัวอธิบายล่าง
      chart.legend.position = 'bottom'; // ตำแหน่งตัวอธิบาย
      chart.legend.valueLabels.template.align = 'right'; // ระยะชิดของข้อความ
      chart.legend.valueLabels.template.textAlign = 'start'; // ระยะชิดของข้อความ
      chart.legend.itemContainers.template.paddingTop = 4; // ระยะห่างคำอธิบาย  บน
      chart.legend.itemContainers.template.paddingBottom = 4; // ระยะห่างคำอธิบาย ล่าง
      // ขนาดของวงสี
      const markerTemplate = chart.legend.markers.template;
      markerTemplate.width = 9;
      markerTemplate.height = 9;
      chart.legend.maxHeight = 110; // ระยะความสูงของคำอธิบาย
      chart.legend.scrollable = true; // ตัวเลื่อน
      series.labels.template.disabled = true; // ปิดเส้นโยง
      this.Legend = false;
    } else if (value == 2) {
      const chart = am4core.create('PieChart', am4charts.PieChart3D);
      chart.hiddenState.properties.opacity = 0;
      this.http.get<any>(this.System.SiteName + 'api/Home/GetPieChart1').subscribe(res => {
        if (res) {
          chart.data = res;
        }
      });
      chart.innerRadius = am4core.percent(0); // ความกว้างของวงตรงกลาง
      chart.depth = 3; // ความสูงของมิติ
      const series = chart.series.push(new am4charts.PieSeries3D());
      series.dataFields.value = 'litres';
      series.dataFields.category = 'country';
      series.slices.template.cornerRadius = 5;
      // series.colors.step = 1; //โทนสีฟ้า 1 / 20
      series.colors.list = [
        am4core.color('#C4B3C3'),
        am4core.color('#FBF1D5'),
        am4core.color('#F7D07A'),
        am4core.color('#FFAE92'),
        am4core.color('#C70039'),
        am4core.color('#47BDD7'),
        am4core.color('#B5E3EA'),
        am4core.color('#48D1CC'),
        am4core.color('#FDB4BF'),
        am4core.color('#D3ECDC'),
        am4core.color('#3A547E'),
        am4core.color('#D0C6DE'),
      ];
      series.labels.template.disabled = false; // เปิดเส้นโยง
      this.Legend = true;
    }
  }

  ThemesChartView() {
    const xychart = am4core.create('ThemesChart', am4charts.XYChart);
    am4core.addLicense('CH208466903'); // รหัสรายเส้น เพาระว่าซื้อมาแล้วต้องใช้ไม่ให้ขึ้นเส้นโลโก
    xychart.hiddenState.properties.opacity = 0;

    // this.sYear = this.sYear.getFullYear().toString();
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    const data = {
      nYear: this.FilterChart.sYear,
      sCurrency: this.FilterChart.sCurrency,
    };
    const ITEM = JSON.stringify(data);
    this.http.post<any[]>(this.System.SiteName + 'api/Home/GetThemesChart', ITEM, {headers, responseType: 'json'}).subscribe(res => {

      // this.http.get<any[]>(this.System.SiteName + "api/Home/GetThemesChart").subscribe(res => {
      // xychart.data = res
      if (res != null) {
        const xychartdata = [];
        for (let i = 0; i <= 4; i++) {
          let TypedateName = '';
          let Amount = null;
          let Invoices = null;
          switch (i) {
            case 0:
              TypedateName = 'Over Due';
              const OverDue = res.filter(f => f.Typedate == 'Over Due').map(ma => {
                Amount = ma.Amount;
                Invoices = ma.Invoices;
              });
              break;
            case 1:
              TypedateName = '<= 5 Day';
              const Day5 = res.filter(f => f.Typedate == '1-5 DAY').map(ma => {
                Amount = ma.Amount;
                Invoices = ma.Invoices;
              });
              break;
            case 2:
              TypedateName = '6-10 Day';
              const Day10 = res.filter(f => f.Typedate == '6-10 DAY').map(ma => {
                Amount = ma.Amount;
                Invoices = ma.Invoices;
              });
              break;
            case 3:
              TypedateName = '11-15 Day';
              const Day15 = res.filter(f => f.Typedate == '11-15 DAY').map(ma => {
                Amount = ma.Amount;
                Invoices = ma.Invoices;
              });
              break;
            case 4:
              TypedateName = '> 15 Day';
              const Day15_LMD = res.filter(f => f.Typedate == '>15 DAY').map(ma => {
                Amount = ma.Amount;
                Invoices = ma.Invoices;
              });
              break;
          }
          xychartdata.push({
            Typedate: TypedateName,
            Amount: Invoices == 0 ? null : Amount,
            Invoices: Invoices
          });
        }
        xychart.data = xychartdata;
      } else {
        const Amount = null;
        const Invoices = null;
        xychart.data = [
          {
            Typedate: 'Over Due',
            Amount: Amount,
            Invoices: Invoices
          },
          {
            Typedate: '1-5 DAY',
            Amount: Amount,
            Invoices: Invoices
          },
          {
            Typedate: '6-10 DAY',
            Amount: Amount,
            Invoices: Invoices
          },
          {
            Typedate: '11-15 DAY',
            Amount: Amount,
            Invoices: Invoices
          },
          {
            Typedate: '>15 DAY',
            Amount: Amount,
            Invoices: Invoices
          }];
      }
    });


    const valueAxis = xychart.yAxes.push(new am4charts.ValueAxis()); // หัวจำนวนเงินให้แสดงตัวอักษร
    valueAxis.title.text = 'Total Amount';
    valueAxis.logarithmic = true; // ให้อันที่สั้นสุดจนมองไม่เห้นให้เห็น
    // Second value axis
    const valueAxis2 = xychart.yAxes.push(new am4charts.ValueAxis());
    valueAxis2.title.text = 'Total Invoices';
    valueAxis2.renderer.opposite = true;
    valueAxis2.min = 0;
    // Create axes
    const categoryAxis = xychart.xAxes.push(new am4charts.CategoryAxis());
    categoryAxis.dataFields.category = 'Typedate';
    // categoryAxis.title.text = "Summary By Due Date";
    categoryAxis.renderer.grid.template.location = 0;
    categoryAxis.renderer.minGridDistance = 20;
    // Create series
    const series = xychart.series.push(new am4charts.ColumnSeries());
    series.dataFields.valueY = 'Amount';
    series.dataFields.categoryX = 'Typedate';
    series.name = 'AMOUNT';
    series.tooltipText = '{name}: [bold]{valueY}[/]';

    xychart.colors.list = [
      // am4core.color("#CCDBE2"),
      am4core.color('#EADB80'),
    ];

    // This has no effect
    // series.stacked = true;
    const series2 = xychart.series.push(new am4charts.ColumnSeries());
    series2.dataFields.valueY = 'Invoices';
    series2.dataFields.categoryX = 'Typedate';
    series2.name = 'INVOICES';
    series2.tooltipText = '{name}: [bold]{valueY}[/]';
    series2.strokeWidth = 3;
    series2.yAxis = valueAxis2;
    // Add cursor
    xychart.cursor = new am4charts.XYCursor();
    // Add legend
    xychart.legend = new am4charts.Legend();
    const markerTemplate = xychart.legend.markers.template;
    markerTemplate.width = 9; // ขนาดของวงสี
    markerTemplate.height = 9; // ขนาดของวงสี
  }

  async seeItem(template: TemplateRef<any>, sRequestID) {
    const ItemData = {
      sRequestID: sRequestID
    };
    const sendData = JSON.stringify(ItemData);
    const headers = new HttpHeaders({
      'Content-Type': 'application/json'
    });
    let data: any;
    if (sendData != null) {
      await this.http.post(this.System.SiteName + 'api/Home/_GetRequestItems', sendData, {
        headers,
        responseType: 'text'
      }).toPromise().then(Data => data = Data);
      this.arrGL = JSON.parse(data);
    }
    const config: ModalOptions = {class: 'gray modal-xl'};
    this.modalRef = this.modalService.show(template, config);
  }

  Export(sRequestID) {
    this.System.BlockUI();
    const ua = this.System.GetUserStorage();
    const link = document.createElement('a');
    link.target = '_blank';
    const httpOptions = {
      params: new HttpParams()
        .set('sReqID', sRequestID + '')
        .set('nContactID', ua.nUserID),
    };
    link.href = this.System.SiteName + 'api/ExportPDF/export?' + httpOptions.params;
    link.setAttribute('visibility', 'hidden');
    link.click();
    this.System.UnBlockUI();
  }

  ChartShow() {
    this.IsChartOpen = !this.IsChartOpen;
  }

  SearchShow() {
    this.IsSearchOpen = !this.IsSearchOpen;
  }

  ClearData() {
    this.FilterGrid.sSearch = '';
    this.FilterGrid.nReqType = [];
    this.FilterGrid.nStatusID = [];
    this.FilterGrid.dDate = [];
    this.FilterGrid.sRequester = [];
    if (this.IsCompanyFilter) {
      const ua = this.System.GetUserStorage();
      this.FilterGrid.sCompanyCode = [];
      ua.lstCompCode.forEach(f =>
        this.FilterGrid.sCompanyCode.push({sValue: f.sCompCode, sText: f.sCompName})
      );
    }
    this.GetData();
  }

  ExportExcel() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    const dataPrepareExport = [];
    for (let x = 0; x < this._ArrData.length; x++) {
      dataPrepareExport.push({
        sRequestCode: this._ArrData[x].sRequestCode,
        sReqType: this._ArrData[x].sReqType,
        sVendorName: this._ArrData[x].sVendorName,
        sDueDate: this._ArrData[x].sDueDate,
        nTotalAmount: this._ArrData[x].nTotalAmount,
        sCurrency: this._ArrData[x].sCurrency,
        sDescription: this._ArrData[x].sDescription,
        sStatusName: this._ArrData[x].sStatusName,
      });
    }

    // {ReqData: this.arrDataExport};
    const Data = JSON.stringify(dataPrepareExport);
    this.http.post(this.System.SiteName + 'api/Home/ExportHomeExcel', Data, {headers, responseType: 'arraybuffer'}).subscribe(res => {
      const blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
      this.save(blob, 'Home.xlsx');
    });
  }

  save(blob, fileName) {
    if (window.navigator.msSaveOrOpenBlob) { // For IE:
      navigator.msSaveBlob(blob, fileName);
    } else { // For other browsers:
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);
    }
  }
}

